import { Box } from '@mui/material';
import React from 'react';
import DynamicTabsComponent from '../../../components/DynamicTabs/DynamicTabsComponent';
import AdminEmployeeOffboarding from './AdminEmployeeOffboarding';
import { useLocation } from 'react-router-dom';

function AdminEmployeeOffboardingComponent() {
  const location = useLocation();
  const xyz = new URLSearchParams(location.search).get('xyz');
  const searchString = window.atob(xyz);

  const orgEmail = new URLSearchParams(searchString).get('orgEmail');
  const status = new URLSearchParams(searchString).get('status');
  const [activeTab, setActiveTab] = React.useState(0);
  const [isEmp, setIsEmp] = React.useState(true);
  const [data, setData] = React.useState({
    status: status,
    orgEmail: orgEmail,
  });

  const options = [
    { value: 'PENDING', label: 'Pending' },
    { value: 'APPROVED', label: 'Approved' },
    { value: 'REJECTED', label: 'Rejected' },
  ];
  React.useEffect(() => {
    if (xyz && status) {
      setData({
        orgEmail: orgEmail,
        status: status,
      });
    }
    if (xyz && status) {
      if (status == 'PENDING') {
        setActiveTab(0);
      }
      if (status == 'APPROVED') {
        setActiveTab(1);
      }
      if (status == 'REJECTED') {
        setActiveTab(2);
      }
    } else {
      setActiveTab(0);
    }
  }, [location]);

  const clearProps = () => {
    setData({
      status: null,
      orgEmail: null,
    });
  };

  const AdminEmployeeOffboardingTab = [
    {
      title: 'Pending',
      index: 0,
      component: (
        <AdminEmployeeOffboarding
          selectedStatus={options[0]}
          orgEmailData={data}
          clearProps={clearProps}
        />
      ),
    },
    {
      title: 'Approved',
      index: 1,
      component: (
        <AdminEmployeeOffboarding
          selectedStatus={options[1]}
          orgEmailData={data}
          clearProps={clearProps}
        />
      ),
    },
    {
      title: 'Rejected',
      index: 2,
      component: (
        <AdminEmployeeOffboarding
          selectedStatus={options[2]}
          orgEmailData={data}
          clearProps={clearProps}
        />
      ),
    },
  ];
  return (
    <div>
      <Box className="main-content-overlay">
        <div className="main-content-div">
          <div>
            <DynamicTabsComponent
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              TabsList={AdminEmployeeOffboardingTab}
              isEmp={isEmp}
            />
          </div>
        </div>
      </Box>
    </div>
  );
}

export default AdminEmployeeOffboardingComponent;
